'use client'

import Section from '../molecules/section';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import Link from 'next/link';

const ShibPortal = () => {
    const t = useTranslations('ShibPortal');
    return (
        <Section
            id="shibPortal"
            backgroundImage="/images/shib_portal_BG.avif"
            className="relative flex flex-col min-h-screen items-center justify-center bg-cover"
        >
            {/* Dark overlay */}
            <div className="absolute inset-0 bg-black opacity-50"></div>

            {/* Top gradient */}
            <div className="absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-black to-transparent"></div>

            {/* Bottom gradient */}
            <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-black to-transparent"></div>

            <div className="relative flex flex-col space-y-4 items-center text-center px-3 pt-[3rem] pb-24">
                <p className="text-white text-center text-base font-semibold leading-4 tracking-widest decoration-skip-ink-0 w-[100%] font-sora uppercase my-4">
                    {t('title')}
                </p>
                <div>
                    <Image
                        src="/logos/shib_portal.svg"
                        width={600}
                        height={120}
                        alt="shib-portal-logo"
                    />
                </div>
                <Image
                    src="/images/shib_portal_laptop.avif"
                    width={600}
                    height={500}
                    sizes="(max-width: 350px) 100%, (max-width: 768px) 100%, (max-width: 1024px) 100%, (max-width: 1200px) 100%, (max-width: 1440px) 100%, (max-width: 1920px) 100%"
                    className="rounded-3xl"
                    alt="shib-portal-logo"
                />
                <div className='flex flex-col'>
                    <p className="text-white text-base leading-6 font-normal sm:w-[100%] md:w-[100%] lg:w-[100%] tracking-[0.36px] font-sora">
                        {t('description')}
                    </p>
                    <p className="text-white text-base leading-6 font-normal sm:w-[100%] md:w-[100%] lg:w-[100%] tracking-[0.36px] font-sora">
                        {t('description2')}
                    </p>
                </div>

                <div className='flex flex-col space-y-4'>
                    <div className="w-56">
                        <Link
                            href={"https://download.shibthemetaverse.io/shibportal-latest-setup.exe"}
                            className="flex items-center justify-center rounded-full border border-[#F17E0E] bg-[#F17E0E] px-4 sm:px-5 sm:py-2 md:py-1.5 lg:py-1.5 text-center text-xs md:text-sm font-medium text-white hover:bg-orange-600 focus:outline-none shadow-[0px_2px_4px_0_rgba(0,0,0,0.4)] backdrop-blur-[24px]"
                        >
                            <Image
                                src="/images/WindowsIcon.png"
                                alt="download"
                                width={28}
                                height={28}
                                className="mr-2"
                            />
                            <div className="flex flex-col items-start">
                                <div className="font-sora text-xs font-normal leading-[12px] text-left decoration-skip-ink-none sm:text-[12px] sm:leading-[14px]">
                                    {t('download')}
                                </div>
                                <div className="font-sora text-xs font-semibold leading-[12px] text-left decoration-skip-ink-none sm:text-[12px] sm:leading-[14px]">
                                    {t('platform')}
                                </div>
                            </div>
                        </Link>
                    </div>
                    <div className="w-56">
                        <Link
                            href={`https://docs.shib.io/docs/playwithshib/portal/intro`}
                            className="flex items-center justify-center rounded-full border border-[#404040] bg-black/50 px-4 py-1.5 text-center text-xs md:text-sm font-medium text-white hover:bg-black focus:outline-none sm:px-6 sm:py-3 shadow-[0px_2px_4px_0_rgba(0,0,0,0.4)] backdrop-blur-[24px]"
                        >
                            {t('guide')}
                        </Link>

                    </div>
                </div>
            </div>
        </Section>
    );
};

export default ShibPortal;